import React from 'react';
import { useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';

export const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    const history = {
      push: (path, state) => {
        if (typeof path === 'string') {
          navigate(path, { state });
        } else {
          // Assume path is object like { pathname, state }
          const { pathname, search, hash, state: pathState } = path;
           navigate({ pathname, search, hash }, { state: pathState || state });
        }
      },
      replace: (path, state) => {
        if (typeof path === 'string') {
          navigate(path, { replace: true, state });
        } else {
          const { pathname, search, hash, state: pathState } = path;
          navigate({ pathname, search, hash }, { replace: true, state: pathState || state });
        }
      },
      location
    };

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        history={history}
        location={location}
        match={{ params }}
      />
    );
  }

  return ComponentWithRouterProp;
};

export const Redirect = ({ to }) => {
    let navigate = useNavigate();
    React.useEffect(() => {
        const target = typeof to === 'string' ? to : (to.pathname + (to.search || ''));
        navigate(target, { replace: true });
    }, [to, navigate]);
    return null;
};
